import axios from "axios";
import { useEffect, useState } from "react";
import { API } from "../../helpers/API";
import "./chatOnline.css";

export default function ChatOnline({ onlineUsers, currentId, setCurrentChat }) {
  const [friends, setFriends] = useState([]);
  const [onlineFriends, setOnlineFriends] = useState([]);

  useEffect(() => {
    const getFriends = async () => {
      const res = await axios.get(`${API}/user/following/${currentId}`);
      setFriends(res.data);
    };

    getFriends();
  }, [currentId]);

  useEffect(() => {
    setOnlineFriends(friends.filter((f) => onlineUsers.includes(f._id)));
  }, [friends, onlineUsers]);

  const handleClick = async (user) => {
    try {
      const res = await axios.get(
        `${API}/conversations/find/${currentId}/${user._id}`
      );
      setCurrentChat(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="chatOnline">
      {onlineFriends.length > 0 ? (
        onlineFriends?.map((o) => (
          <div
            className="chatOnlineFriend"
            onClick={() => handleClick(o)}
            key={o._id}
          >
            <div className="chatOnlineImgContainer">
              <img className="chatOnlineImg" src={o?.avatar} alt="" />
              <div className="chatOnlineBadge"></div>
            </div>
            <span className="chatOnlineName">{o?.name}</span>
          </div>
        ))
      ) : (
        <p>No friend online ;(</p>
      )}
    </div>
  );
}
